<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="dark">
            <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          accordion="my-accordion"
          role="tabpanel"
          visible
        >
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان فارسی: </strong
                  >{{ proposal.faSubject }}
                </li>

                <li>
                  <strong class="c-purple"
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟
                  </strong>
                  <b-form-radio-group
                    v-model="proposal.initialIsSupported"
                    disabled
                  >
                    <b-form-radio :value="true">بله</b-form-radio>
                    <b-form-radio :value="false">خیر</b-form-radio>
                  </b-form-radio-group>
                </li>

                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">حمایت ها: </strong
                  >{{
                    proposal.initialSupportedType
                      ? options.filter(
                          (x) => x.value == proposal.initialSupportedType
                        )[0].text
                      : ""
                  }}
                </li>
                <li v-if="proposal.initialSupportedType == 'other'">
                  <strong class="c-purple">عنوان حمایت دریافتی: </strong
                  >{{ proposal.initialOtherSupport }}
                </li>
                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">توضیحات حمایت دریافتی: </strong
                  >{{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="light">
            <h5 class="mb-0" style="display: inline-block">
              اطلاعات اصلی دوره‌&nbsp;
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان فارسی: </strong>
                  {{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple">عنوان به زبان انگلیسی: </strong>
                  {{ proposal.enSubject }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل اجرای دوره: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li v-if="proposal.universityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong>
                  {{ proposal.otherUniversity }}
                </li>
                <li v-if="proposal.mehvarId != notMehvar">
                  <strong class="c-purple">محور دوره: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">محور دوره:</strong>
                  سایر محورها
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">نام محور: </strong
                  >{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong class="c-purple">ماهیت دوره: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.typeStudy"
                      >مطالعاتی</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="proposal.typeSystemicDevelopmental"
                      >سیستمی و توسعه‌ای</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.typePractical"
                      >کاربردی</b-form-checkbox
                    >
                  </b-form-group>
                </li>
                <li>
                  <strong class="c-purple">حوزه دوره: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.zoneMedicine"
                      >پزشکی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneAgriculture"
                      >کشاورزی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneEnvironment"
                      >محیط زیست</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneIndustrial"
                      >صنعتی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneBioComputing"
                      >رایانش زیستی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneOther"
                      >سایر</b-form-checkbox
                    >
                  </b-form-group>
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-3 variant="light">
            <h5 class="mb-0" style="display: inline-block">اطلاعات پژوهشگر</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">نام: </strong
                  >{{ proposal.researcherName }}
                </li>
                <li>
                  <strong class="c-purple">نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li>
                  <strong class="c-purple">کدملی:</strong
                  >{{ proposal.researcherNatCode }}
                </li>
                <li>
                  <strong class="c-purple">تلفن همراه: </strong
                  >{{ proposal.researcherMobile }}
                </li>
                <li>
                  <strong class="c-purple">دورنگار: </strong
                  >{{ proposal.researcherFax }}
                </li>
                <li>
                  <strong class="c-purple">پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li>
                  <strong class="c-purple">استان: </strong
                  >{{ proposal.researcherState }}
                </li>
                <li>
                  <strong class="c-purple">شهر: </strong
                  >{{ proposal.researcherCity }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل تحصیل: </strong
                  >{{
                    universities.filter(
                      (x) => x.id == proposal.researcherUniversityId
                    ).length
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : "---"
                      : "---"
                  }}
                </li>
                <li v-if="proposal.researcherUniversityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li>
                  <strong class="c-purple">رشته تحصیلی مقطع دکتری: </strong
                  >{{ proposal.researcherPhDField }}
                </li>
                <li>
                  <strong class="c-purple">عنوان رساله دکتری: </strong
                  >{{ proposal.researcherPhDThesisSubject }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ دفاع: </strong
                  >{{ proposal.researcherPhDThesisDefenceDate }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ دریافت مدرک دکتری: </strong
                  >{{ proposal.researcherPhDCertificateDate }}
                </li>
                <br />
                <b-form-group disabled>
                  <div class="d-flex" dir="rtl">
                    <b-form-checkbox
                      :value="true"
                      v-model="proposal.researcherArticle"
                    ></b-form-checkbox>
                    <label class="ml-2"
                      ><h6 class="c-purple">
                        مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                      </h6></label
                    >
                  </div>
                </b-form-group>
                <div v-if="proposal.researcherArticle">
                  <li>
                    <strong class="c-purple"
                      >شناسه دیجیتالی مقاله (اول):
                    </strong>
                    {{ proposal.researcherDoi1 }}
                  </li>

                  <br />
                  <li>
                    <strong class="c-purple"
                      >شناسه دیجیتالی مقاله (دوم):
                    </strong>
                    {{ proposal.researcherDoi2 }}
                  </li>

                  <br />
                  <li>
                    <strong class="c-purple"
                      >شناسه دیجیتالی مقاله (سوم):
                    </strong>
                    {{ proposal.researcherDoi3 }}
                  </li>
                </div>
                <br />
                <b-form-group disabled>
                  <div class="d-flex" dir="rtl">
                    <b-form-checkbox
                      :value="true"
                      v-model="proposal.researcherInternationalPatent"
                    ></b-form-checkbox>
                    <label class="ml-2"
                      ><h6 class="c-purple">ثبت اختراع بین‌المللی</h6></label
                    >
                  </div>
                </b-form-group>

                <div v-if="proposal.researcherInternationalPatent">
                  <b-row>
                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                      <strong class="c-purple">عنوان اختراع: </strong>
                      {{ proposal.researcherInternationalPatentTitle }}
                    </b-col>
                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                      <strong class="c-purple">سال اختراع: </strong>
                      {{ proposal.researcherInternationalPatentYear }}
                    </b-col>
                  </b-row>
                  <b-row class="my-0 py-0">
                    <b-col cols="12">
                      <strong class="c-purple">توضیحات اختراع: </strong>
                      {{ proposal.researcherInternationalPatentDescription }}
                    </b-col>
                  </b-row>
                </div>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="warning">
            <h5 class="mb-0" style="display: inline-block">
              اطلاعات مسئول دوره پسا دکتری
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text v-if="proposal.supervisors.length">
              <ul>
                <li>
                  <strong class="c-purple">نام: </strong
                  >{{ proposal.supervisors[0].name }}
                </li>
                <li>
                  <strong class="c-purple">نام خانوادگی: </strong
                  >{{ proposal.supervisors[0].lastName }}
                </li>
                <li>
                  <strong class="c-purple">کدملی:</strong
                  >{{ proposal.supervisors[0].natCode }}
                </li>
                <li>
                  <strong class="c-purple">تلفن همراه: </strong
                  >{{ proposal.supervisors[0].mobile }}
                </li>
                <li>
                  <strong class="c-purple">پست الکترونیکی: </strong
                  >{{ proposal.supervisors[0].email }}
                </li>
                <li>
                  <strong class="c-purple">سمت: </strong
                  >{{ proposal.supervisors[0].position }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل تحصیل: </strong>
                  {{
                    universities.filter(
                      (x) => x.id == proposal.supervisors[0].universityId
                    ).length
                      ? universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.supervisors[0].universityId
                          )[0].text
                        : "---"
                      : "---"
                  }}
                </li>
                <li
                  v-if="proposal.supervisors[0].universityId == notUniversity"
                >
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.supervisors[0].universityOther }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل اشتغال: </strong>
                  {{
                    proposal.supervisors[0].universityJobId
                      ? universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityJobId
                        )[0]
                        ? universities.filter(
                            (x) =>
                              x.id == proposal.supervisors[0].universityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  v-if="
                    proposal.supervisors[0].universityJobId == notUniversity
                  "
                >
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.supervisors[0].universityJobOther }}
                </li>
                <li>
                  <strong class="c-purple">نوع هیئت علمی: </strong>
                  {{ proposal.supervisors[0].scienceCommitteeType }}
                </li>
                <li>
                  <strong class="c-purple">آخرین مدرک تحصیلی: </strong>
                  {{ proposal.supervisors[0].lastDegree }}
                </li>
                <li>
                  <strong class="c-purple">عنوان رساله دکتری: </strong>
                  {{ proposal.supervisors[0].phdThesisSubject }}
                </li>
                <li>
                  <strong class="c-purple">مرتبه علمی: </strong
                  >{{ proposal.supervisors[0].academicRank }}
                </li>
              </ul>
              <b-form-group disabled>
                <div class="d-flex" dir="rtl">
                  <b-form-checkbox
                    :value="true"
                    v-model="proposal.supervisors[0].article"
                  ></b-form-checkbox>
                  <label class="ml-2"
                    ><h6 class="c-purple">
                      مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                    </h6></label
                  >
                </div>
              </b-form-group>
              <div v-if="proposal.supervisors[0].article">
                <li>
                  <strong class="c-purple">شناسه دیجیتالی مقاله (اول): </strong>
                  {{ proposal.supervisors[0].doi1 }}
                </li>

                <br />
                <li>
                  <strong class="c-purple">شناسه دیجیتالی مقاله (دوم): </strong>
                  {{ proposal.supervisors[0].doi2 }}
                </li>

                <br />
                <li>
                  <strong class="c-purple">شناسه دیجیتالی مقاله (سوم): </strong>
                  {{ proposal.supervisors[0].doi3 }}
                </li>

                <br />
                <li>
                  <strong class="c-purple"
                    >شناسه دیجیتالی مقاله (چهارم):
                  </strong>
                  {{ proposal.supervisors[0].doi4 }}
                </li>

                <br />
                <li>
                  <strong class="c-purple"
                    >شناسه دیجیتالی مقاله (پنجم):
                  </strong>
                  {{ proposal.supervisors[0].doi5 }}
                </li>
              </div>
              <br />
              <b-form-group>
                <div class="d-flex" dir="rtl">
                  <b-form-checkbox
                    :value="true"
                    v-model="proposal.supervisors[0].internationalPatent"
                  ></b-form-checkbox>
                  <label class="ml-2"
                    ><h6 class="c-purple">ثبت اختراع بین‌المللی</h6></label
                  >
                </div>
              </b-form-group>

              <div v-if="proposal.supervisors[0].internationalPatent">
                <b-row>
                  <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <strong class="c-purple">عنوان اختراع: </strong
                    >{{ proposal.supervisors[0].internationalPatentTitle }}
                  </b-col>
                  <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <strong class="c-purple">سال اختراع: </strong
                    >{{ proposal.supervisors[0].internationalPatentYear }}
                  </b-col>
                </b-row>
                <b-row class="my-0 py-0">
                  <b-col cols="12">
                    <strong class="c-purple">توضیحات اختراع: </strong
                    >{{
                      proposal.supervisors[0].internationalPatentDescription
                    }}
                  </b-col>
                </b-row>
              </div>
              <br />
              <b-form-group disabled class="mt-2">
                <div class="d-flex" dir="rtl">
                  <b-form-checkbox
                    :value="true"
                    v-model="proposal.supervisors[0].researchFestivals"
                  ></b-form-checkbox>
                  <label class="ml-2"
                    ><h6 class="c-purple">
                      اعضای برگزیده جشنواره های پژوهشی
                    </h6></label
                  >
                </div>
              </b-form-group>
              <li v-if="proposal.supervisors[0].researchFestivals">
                <strong class="c-purple">عنوان جشنواره: </strong>
                {{ proposal.supervisors[0].researchFestivalsTitle }}
              </li>
              <br />
              <b-form-group class="mt-2" disabled>
                <div class="d-flex" dir="rtl">
                  <b-form-checkbox
                    :value="true"
                    v-model="proposal.supervisors[0].notSupervisor"
                  ></b-form-checkbox>
                  <label class="ml-2"
                    ><h6 class="c-purple">
                      اگر استاد راهنمای متقاضی نیستید تیک را بزنید
                    </h6></label
                  >
                </div>
              </b-form-group>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-5 variant="info">
            <h5 class="mb-0 text-white" style="display: inline-block">
              مشخصات دوره
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">چکیده دوره: </strong
                  >{{ proposal.abstract }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"
                    >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                    راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                  >{{ proposal.requestNecessity }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">اهداف کلان دوره:</strong
                  >{{ proposal.majorGoals }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">اهداف خرد دوره:</strong
                  >{{ proposal.minorGoals }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">مزایای دیگر برای کشور: </strong
                  >{{ proposal.benefitsToCountry }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"
                    >روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                  >{{ proposal.methodology }}
                </li>
                <hr />
                <li v-if="proposal.requestProducts.length > 0">
                  <strong class="c-purple"
                    >دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                    خدمات) حاصل از اجرای دوره:
                  </strong>
                  <!-- NOTE (t-proposal.requestProducts-2) previous -->
                  <div class="custom-table">
                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="proposal.requestProducts"
                      :fields="achievmentFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary my-3"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </div>
                </li>
                <hr />
                <li>
                  <strong class="c-purple"
                    >سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج از كشور (با
                    ذكر ماخذ): </strong
                  >{{ proposal.executionHistorySimilar }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"
                    >شركای بین‌المللی در اجرای دوره :
                  </strong>
                  {{ proposal.internationalPartners }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">منابع و ماخذ: </strong
                  >{{ proposal.references }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"
                    >حمایتهای احتمالی قبلی ستاد از دوره:
                  </strong>
                  {{ proposal.postDocLastSupports }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-7 variant="light">
            <h5 class="mb-0" style="display: inline-block">زمان‌بندی دوره</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3 shadow">
              <b class="c-purple">زمان شروع:</b>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : ""
              }}
              <br />
              <b class="c-purple">زمان پایان:</b>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : ""
              }}
              <br />
              <b class="c-purple">مدت زمان:</b>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
              <br />
              <br />
              <div>
                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-8 variant="dark">
            <h5 class="mb-0" style="display: inline-block">هزینه‌ها</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <div v-if="proposal.personnelCosts.length > 0">
                <hr />
                <h5 class="mt-5 mb-3 c-purple">
                  هزینه‌های پرسنلی اعم از مجری و همكاران
                </h5>

                <!-- NOTE (t-personnelCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="proposal.personnelCosts"
                    :fields="PersonnelCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(humanResourceCost)="data">
                      <div>
                        {{
                          (
                            parseInt(data.item.perPersonCost) *
                            parseInt(data.item.cooperationHour)
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                </div>
                <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                <p>
                  جمع کل هزینه های پرسنلی:
                  {{
                    proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </p>
              </div>

              <div v-if="proposal.travelExpenses.length > 0">
                <h5 class="mt-5 mb-3 c-purple">
                  هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                  نقل، حق مأموریت و ...):
                </h5>

                <!-- NOTE (t-tripCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="proposal.travelExpenses"
                    :fields="tripCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
                جمع کل مسافرتهای ضروری:
                {{
                  proposal.travelExpenses.length == 0
                    ? 0
                    : proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>
              <div v-if="proposal.purchases.length > 0">
                <h5 class="mt-5 mb-3 c-purple">
                  هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل اعتبار
                  طرح خریداری شوند:
                </h5>

                <!-- NOTE (t-deviceCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="proposal.purchases"
                    :fields="deviceCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div>
                        {{
                          (
                            parseInt(data.item.number) *
                            parseInt(data.item.perPrice)
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                </div>
                جمع کل هزینه دستگاه‌ها:
                {{
                  proposal.purchases.length == 0
                    ? 0
                    : proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
                <hr />
              </div>

              <div v-if="proposal.participationOrganizationBudget.length > 0">
                <h5 class="mt-5 mb-3 c-purple">میزان مشارکت سایر موسسات:</h5>

                <!-- NOTE (t-orgCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="proposal.participationOrganizationBudget"
                    :fields="OrgCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
                جمع کل مشارکت موسسات:
                {{
                  proposal.participationOrganizationBudget.length == 0
                    ? 0
                    : proposal.participationOrganizationBudget
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>
              <div
                v-show="
                  proposal.otherCosts
                    .map((x) => x.totalPrice)
                    .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                "
              >
                <h5 class="mt-5 mb-3 c-purple">هزینه‌های دیگر:</h5>

                <!-- NOTE (t-otherCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="proposal.otherCosts"
                    :fields="otherCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
                <p>
                  جمع کل سایر هزینه‌ها:
                  {{
                    proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </p>
              </div>
              <h3>
                جمع کل هزینه‌ها:
                {{
                  (tPrice = (
                    (proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.travelExpenses.length == 0
                      ? 0
                      : proposal.travelExpenses
                          .map((x) => x.cost)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.purchases.length == 0
                      ? 0
                      : proposal.purchases
                          .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                  ).toLocaleString())
                }}
                تومان
              </h3>
              <hr />
              <h3>
                میزان اعتبار مورد نیاز از ستاد زیست فناوری:
                {{ computedTotalCost.toLocaleString() }}
                تومان
              </h3>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-9 variant="dark">
            <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <b-form-group disabled>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                >
                  این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                  مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                >
                  این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                  انجام:
                  {{
                    (tPrice = (
                      (proposal.personnelCosts.length == 0
                        ? 0
                        : proposal.personnelCosts
                            .map(
                              (x) =>
                                parseInt(x.perPersonCost) *
                                parseInt(x.cooperationHour)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.travelExpenses.length == 0
                        ? 0
                        : proposal.travelExpenses
                            .map((x) => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.purchases.length == 0
                        ? 0
                        : proposal.purchases
                            .map(
                              (x) => parseInt(x.perPrice) * parseInt(x.number)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.otherCosts.length == 0
                        ? 0
                        : proposal.otherCosts
                            .map((x) => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                    ).toLocaleString())
                  }}
                  تومان
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                  می‌باشد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                  دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                >
                  بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                  بهره‌بردار:
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                  می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت انجام
                  خواهد شد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[8]"
                  >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام طرح
                  به ستاد زیست فناوری ارسال و تحویل داده
                  می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[9]"
                  >کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام و در
                  سایت بارگذاری می‌گردد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[10]"
                  >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[11]"
                  >سوابق پژوهشگر با موضوع دوره منطبق است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[12] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[12]"
                  >سوابق استاد راهنما با موضوع دوره منطبق است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[13] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[13]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                  به عنوان مجری طرح و همکاران می‌باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  props: ["proposal", "universities", "mehvars", "companies"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      expireDisable: false,
      pageLoaded: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,

      acc: 0,
      moment: moment,
      show: false,
      checkbox: "",
      checkbox2: "",
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      colleague: {},
      fileFilter: "",
      zone: new Array(6).fill(false),
      tabIndex: 0,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      dr: {},
      selectedMehvar: 0,
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
      ],
      perCosts: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      perPrices: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      adminToReferee: "",
      options1: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      options2: [
        {
          value: "تمام وقت",
          text: "تمام وقت",
        },
        {
          value: "پاره وقت",
          text: "پاره وقت",
        },
      ],
      sources: [
        {
          value: "داخلی",
          text: "داخلی",
        },
        {
          value: "خارجی",
          text: "خارجی",
        },
      ],

      deviceTypes: [
        { value: "مصرفی", text: "مصرفی" },
        { value: "سرمایه‌ای", text: "سرمایه‌ای" },
      ],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت (تومان)" },
        { key: "perPersonCost", label: "نفر ساعت مورد نیاز" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
      ],
      inventionItem: [],
      rejectMessage: "",
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "Iyear", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      inventionFieldMaster: [
        { key: "Msubject", label: "عنوان" },
        { key: "Myear", label: "سال" },
        { key: "Mdescription", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      file: null,
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      allCostItem: [
        { name: "پرسنلی ", totalPrice: 0 },
        { name: "ارتباطات، حمل ونقل ، پست ، دورنویس و باربری", totalPrice: 0 },
        { name: "هزینه های پیش بینی نشده", totalPrice: 0 },
      ],
      allCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "پرسنلی ", label: "پرسنلی" },
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
      ],
      uploadedFiles: new Array(10).fill({
        title: "",
        description: "",
      }),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      isLoaded: true,
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
  computed: {
    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
